import { IResponseWebhook, IResponseWebhookRequestParam, IWebhook, IWebhookRequestParam } from '../types/webhooks';

const _webhookParamCast = (data: IResponseWebhookRequestParam): IWebhookRequestParam => {
  return { ...data, frontId: data.id };
};

export const webhookCast = (data: IResponseWebhook): IWebhook => {
  return {
    id: data.id,
    name: data.name,
    language: data.language,
    url: data.url,
    type: data.type,
    method: data.method,
    headers: data.headers?.length ? data.headers.map((param) => _webhookParamCast(param)) : [],
    parameters: data.parameters?.length ? data.parameters.map((param) => _webhookParamCast(param)) : [],
    statuses: data.order_statuses || [],
    counter: data.count,
    status: data.status,
  };
};

const _getWebhookParam = (data: IWebhookRequestParam) => {
  return {
    id: data.id,
    frontId: undefined,
    key: data.key,
    value: data.value,
  };
};

export const getWebhookParams = (data: IWebhook) => {
  return {
    id: data.id ? data.id : undefined,
    name: data.name,
    language: data.language,
    url: data.url,
    type: data.type,
    method: data.method,
    headers: data.headers.length ? data.headers.map((param) => _getWebhookParam(param)) : [],
    parameters: data.parameters.length ? data.parameters.map((param) => _getWebhookParam(param)) : [],
    order_statuses: data.statuses,
    created_at: undefined,
    updated_at: undefined,
    counter: undefined,
    status: data.status,
  };
};
